import { useCallback } from "react";
import { Button, PaginationProps, useListPaginationContext } from "react-admin";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import "./SimplePagination.css";

const SimplePagination = (props: PaginationProps) => {
  const {
    page,
    setPage,
    perPage,
    setPerPage,
    total,
  } = useListPaginationContext(props);
  const nbPages = Math.ceil(total / perPage);
  const rowsPerPage = props.rowsPerPageOptions || [5, 10, 25];

  const handlePerPageChange = useCallback(
    (event) => {
      setPerPage(event.target.value);
    },
    [setPerPage]
  );

  return (
    <div className="simple-pagination">
      <div className="simple-pagination">
        <p>Rows per page:</p>
        <Select value={perPage} onChange={handlePerPageChange}>
          {rowsPerPage.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </div>
      <Button
        onClick={() => setPage(Math.max(1, page - 1))}
        disabled={page === 1}
        label="PREV"
      >
        <ChevronLeftIcon />
      </Button>
      <Button
        onClick={() => setPage(Math.min(nbPages, page + 1))}
        disabled={page >= nbPages}
        label="NEXT"
        endIcon={<ChevronRightIcon />}
      />
    </div>
  );
};

export default SimplePagination;
